/**
 * Browser tab title for a match page, HLTV style: "[11-1] Team A vs Team B".
 *   live      → score of the map being played
 *   finished  → series score (BO3/BO5) or the map score (BO1)
 *   otherwise → team names only (pending / cancelled)
 * During a team's tech pause (live timer `match_timer_update`: type 'paused', pause_kind 'tech')
 * it starts with "Tech - <team> | ". Uses whatever the page shows, so a public stream-delayed
 * page gets the delayed score and pause.
 */
export function matchTabTitle(match, timer) {
  if (!match) return null;
  const names = `${match.team1_name || 'Team 1'} vs ${match.team2_name || 'Team 2'}`;
  const n = (v) => parseInt(v, 10) || 0;
  if (match.status === 'live') {
    const tech = timer && timer.type === 'paused' && timer.pause_kind === 'tech' && Number(timer.match_id) === Number(match.id)
      ? `Tech - ${timer.team_name || 'Team'} | ` : '';
    return `${tech}[${n(match.score_team1)}-${n(match.score_team2)}] ${names}`;
  }
  if (match.status === 'finished') {
    const series = (parseInt(match.best_of, 10) || 1) > 1;
    return series
      ? `[${n(match.map_wins_team1)}-${n(match.map_wins_team2)}] ${names}`
      : `[${n(match.score_team1)}-${n(match.score_team2)}] ${names}`;
  }
  return names;
}
